/**
 * Send application to u-on.travel via webhook
 * Uses Vercel serverless function to avoid CORS issues
 * @param {Object} data - Application data
 * @returns {Promise<boolean>} - Success status
 */
export const sendToUon = async (data) => {
  // Use relative path for Vercel API
  const API_ENDPOINT = '/api/send-to-uon';
  
  try {
    // Format data for u-on (matching admin panel structure)
    const payload = {
      name: data.name || '',
      phone: data.phone || '',
      tour_name: data.tour_name || '',
      page_url: data.page_url || window.location.pathname,
      status: 'new',
      source: 'website'
    };

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Application sent to u-on:', result);
    return true;
  } catch (error) {
    console.error('Error sending to u-on:', error);
    // Don't fail the form submission if u-on fails
    // The data is still saved to Supabase
    return false;
  }
};
